import { render, staticRenderFns } from "./EducationManage.vue?vue&type=template&id=193d5d05&scoped=true"
import script from "./EducationManage.vue?vue&type=script&lang=js"
export * from "./EducationManage.vue?vue&type=script&lang=js"
import style0 from "./EducationManage.vue?vue&type=style&index=0&id=193d5d05&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "193d5d05",
  null
  
)

export default component.exports